(function () {
	var App = angular.module('pphhApp');
	
	App.controller("CRUDSourceDialogController", ["$scope", "$mdDialog", "$http", "entity", 
		"fieldName", "multiple", "selectedValues", CRUDSourceDialogController]);
	
	App.controller("CRUDSourceDialogControllerEdicionMedidas", ["$scope", "$mdDialog", "$http", "entity", 
		"fieldName", "multiple", "selectedValues", "currentViewType", CRUDSourceDialogControllerEdicionMedidas]);
	
	App.controller("CRUDSourceDialogControllerAuxUd", ["$scope", "$mdDialog", "$http", "entity", 
		"fieldName", "multiple", "selectedValues", "currentViewType", CRUDSourceDialogControllerAuxUd]);
	
	App.controller("CRUDSourceDialogControllerSubtipoIph", ["$scope", "$mdDialog", "$http", "entity", 
		"fieldName", "multiple", "selectedValues", "currentViewType", CRUDSourceDialogControllerSubtipoIph]);
	
	App.controller("CRUDSourceDialogControllerEdicionObrasIg", ["$scope", "$mdDialog", "$http", "entity", 
		"fieldName", "multiple", "selectedValues", "currentViewType", CRUDSourceDialogControllerEdicionObrasIg]);
		
	App.controller("CRUDSourceDialogControllerCommonPi", ["$scope", "$mdDialog", "$http", "entity", 
		"fieldName", "multiple", "selectedValues", "currentViewType", CRUDSourceDialogControllerCommonPi]);
	
	/**
	 * Controller para el control de lookup que se muestra en las búsquedas y en la edición en línea.<br>
	 * Puntos de extensión:
	 *  - Método customValidation.
	 *  - Método customInit.
	 *  - Atributo requiredField.
	 * @param $scope
	 * @param $mdDialog
	 * @param $http
	 * @param entity El nombre de la entidad.
	 * @param fieldName El nombre del campo sobre el que se hace lookup.
	 * @param multiple Valor lógico que indica si se admite selección múltiple o no.
	 * @param selectedValues Los valores anteriormente seleccionados si existen.
	 * @returns <code>true</code>
	 */
	function CRUDSourceDialogController($scope, $mdDialog, $http, entity, fieldName, multiple,
			selectedValues) {
		var self = this;
	
		$scope.md = {};
	
		$scope.sourceResults = [];
	
		$scope.filter = {};
	
		$scope.requiredField = null;
	
		$scope.selectedRows = [];
		if (selectedValues) {
			$scope.selectedRows = selectedValues;
		}
		
		$scope.lastValidParams = undefined;
	
		$scope.multiple = multiple;
	
		$scope.init = init;
		
		$scope.selectOnSource = selectOnSource;
		$scope.deselectValue = deselectValue;
		$scope.endSelection = endSelection;
		
		$scope.isFormValid = isFormValid;
		$scope.lookup = lookup;
		$scope.doLookup = doLookup;
		$scope.selectAll = selectAll;
		$scope.deselectAll = deselectAll;
		
		
		function init() {
			$http({
				method: "GET",
				url: "/crud/sourceDialog-md/" + entity.entityName
					+ "/" + fieldName
			})
			.then(
				function (response) {
					$scope.md = response.data;
	
					if (self.customInit) {
						self.customInit();
					}
				}
			);
		}
	
		function selectOnSource(row) {
			var value = [];
			for(var i = 0; i < $scope.md.valueFields.length; i++) {
				value[value.length] = row[$scope.md.valueFields[i]];
			}
	
			var found = false;
			for(i = 0; !found && i < $scope.selectedRows.length; i++) {
				found = $scope.selectedRows[i].id == row[$scope.md.keyField];
			}
	
			if(!found) {
				$scope.selectedRows[$scope.selectedRows.length] = {
					id: row[$scope.md.keyField],
					value: value.join(" - ")
				};
			}
	
			if(!multiple) {
				$scope.endSelection();
			}
		}
	
		function deselectValue(index) {
			$scope.selectedRows.splice(index, 1);
		}
	
		function endSelection() {
			$mdDialog.hide($scope.selectedRows);
		}
	
		function isFormValid() {
		    return $scope.lookupForm
		    	&& $scope.lookupForm.$valid
		    	&& (!self.customValidation
		    			|| (self.customValidation && self.customValidation()));
		}
	
		function lookup() {
			var tableState = $scope.stCtrl.tableState();
			SmartTableUtils.reset(tableState);
			$scope.stCtrl.pipe();
		}
	
		function doLookup(tableState, ctrl) {
	
			if (!$scope.stCtrl && ctrl) {
		        $scope.stCtrl = ctrl;
		    }
	
		    if (!tableState && $scope.stCtrl) {
		        $scope.stCtrl.pipe();
		        return;
		    }
	
		    if (!$scope.isFormValid()) {
		    	return;
		    }
		    
		    var params = angular.copy($scope.filter);
		    angular.forEach(params, function (value, name, filterCriteria) {
		    	if (value === "") {
		    		filterCriteria[name] = null;
		    	}
		    });

			$scope.lastValidParams = params;
			 
		    SmartTableUtils.setGenericPaginationParams(tableState, params);
	
			$http({
				method: "GET",
				url: "/crud/sourceDialog/" + entity.entityName
					+ "/" + entity.id + "/" + fieldName,
				params: params
			})
			.then(
				function (response) {
					var queryResults = response.data;
					if (response.data.results) {						
						$scope.sourceResults = queryResults.results;
						$scope.sourcePageSize = queryResults.pageSize;
						SmartTableUtils.updateTableState(tableState, queryResults);
					}
				},
				function () {
					$mdDialog.show(
							$mdDialog.alert({
								title: UIMessages.dialog.confirm.title,
								textContent: "Error lookup",
								ok: UIMessages.dialog.confirm.cerrar
							}));
				}
			);
		}
		
		function deselectAll() {
			$scope.selectedRows.length = 0;
		}
			
		function selectAll() {
	
			console.log ($scope.md.valueFields);
			var params = $scope.lastValidParams;		
			params["noPagination"]=true;
	
			$http({
				method: "GET",
				url: "/crud/sourceDialog/" + entity.entityName
					+ "/" + entity.id + "/" + fieldName,
				params: params			
			})
			.then(
				function (response) {
					var queryResults = response.data;
					if (response.data.results) {						
						for ( var r = 0; r< queryResults.results.length;r++){
							var record = queryResults.results[r];
							var value = [];
							for(var i = 0; i < $scope.md.valueFields.length; i++) {
								value[value.length] = record[$scope.md.valueFields[i]];
							}
							var found = false;
							for(i = 0; !found && i < $scope.selectedRows.length; i++) {
								found = $scope.selectedRows[i].id == record[$scope.md.keyField];
							}
							if(!found) {
								$scope.selectedRows[$scope.selectedRows.length] = {
									id: record[$scope.md.keyField],
									value: value.join(" - ")
								};
							}
						}
					}
				},
				function () {
					$mdDialog.show(
							$mdDialog.alert({
								title: UIMessages.dialog.confirm.title,
								textContent: "Error lookup",
								ok: UIMessages.dialog.confirm.cerrar
							}));
				}
			);
		}		
	}
	
	function CRUDSourceDialogControllerEdicionMedidas($scope, $mdDialog, $http, entity, fieldName,
			multiple, selectedValues, currentViewType) {
	
		CRUDSourceDialogController.call(this, $scope, $mdDialog, $http, entity, fieldName,
				multiple, selectedValues);
	
		var medidaId = null;
	
		if(currentViewType === "formView") {
			medidaId = entity.form.medida.value;
		} else {
			medidaId = entity.filter.fields.medida.value;
		}
	
		if(currentViewType === "formView" || medidaId != null) {
			$scope.filter["_measure_lookup_"] = 1;
			$scope.filter["_id_"] = medidaId;
		}
	
		this.customValidation = function () {
			var medidaField = null;
			if(currentViewType === "formView") {
				medidaField = entity.form.medida;
	
				if(medidaField.value == null) {
					$scope.requiredField = medidaField;
					return false;
				}
			}
	
			return true;
		};
	}
	
	function CRUDSourceDialogControllerAuxUd($scope, $mdDialog, $http, entity, fieldName,
			multiple, selectedValues, currentViewType) {
	
		CRUDSourceDialogControllerEdicionMedidas.call(this, $scope, $mdDialog, $http, entity,
				fieldName, multiple, selectedValues, currentViewType);
	
		$scope.tipos = {};
	
		this.customInit = function () {
			$scope.filter["rbd__op"] = "EQ";
			$scope.filter["tipoUd__op"] = "EQ";
	
			$http.get("/cc/tiposServicioAgua")
			.then(function (response) {
				$scope.tipos = response.data;
			});
			
			$http.get("/cc/queries/todasDemarcaciones").then(
					function (response) {
						$scope.rbds = response.data;
					});
		};
	}
		
	function CRUDSourceDialogControllerSubtipoIph($scope, $mdDialog, $http, entity, fieldName, multiple,
			selectedValues, currentViewType) {
	
		CRUDSourceDialogController.call(this, $scope, $mdDialog, $http, entity, fieldName, multiple,
				selectedValues);
	
		$scope.tipos = {};
		$scope.subtipos = {};
	
		$scope.filter.tipo = null;
		$scope.filter.auxSubtiposMedClave = null;
	
		this.customInit = function () {
			$scope.filter["auxSubtiposMedClave__op"] = "EQ";
	
			$http.get("/cc/tiposMedClave")
			.then(function (response) {
				$scope.tipos = response.data;
			});
	
			$scope.$watch("filter.tipo", function (val) {
				if(!val) {
					$scope.subtipos = {};
				} else {
					$http.get("/cc/subtiposMedClave/" + val)
					.then(function (response) {
						$scope.subtipos = response.data;
					});
				}
			});
		};
	
		this.customValidation = function () {
			if($scope.filter.tipo && !$scope.filter.auxSubtiposMedClave) {
				return false;
			}
			return true;
		};
	}
	
	function CRUDSourceDialogControllerEdicionObrasIg($scope, $mdDialog, $http, entity, fieldName, multiple,
			selectedValues, currentViewType){
		
		CRUDSourceDialogController.call(this, $scope, $mdDialog, $http, entity, fieldName, multiple,
				selectedValues);
		var obraIgId = null;
		
		if(currentViewType === "formView") {
			obraIgId = entity.form.obraIg.value;
		} else {
			obraIgId = entity.filter.fields.obraIg.value;
		}
		
		
		
		if(currentViewType === "formView" || obraIgId != null) {
			$scope.filter["_obraig_lookup_"] = 1;
			$scope.filter["_id_"] = obraIgId;
		}
	
		this.customValidation = function () {
			var obraIgField = null;
			if(currentViewType === "formView") {
				obraIgField = entity.form.obraIg;
	
				if(obraIgField.value == null) {
					$scope.requiredField = obraIgField;
					return false;
				}
			}
	
			return true;
		};
	};

	function CRUDSourceDialogControllerCommonPi($scope, $mdDialog, $http, entity, fieldName, multiple,
			selectedValues, currentViewType) {
	
		CRUDSourceDialogController.call(this, $scope, $mdDialog, $http, entity, fieldName, multiple,
				selectedValues);
	
		this.customInit = function () {
			
			$http.get(_contextPath + "/cc/queries/todasDemarcaciones").then(
					function (response) {
						$scope.rbds = response.data;
					});
		};
	}	
})();
